<body
  [ngClass]="{
'opening': !is3DView,
'view-3D': is3DView,
'view-2D': !is3DView,
'hide-UI': !is3DView,
'set-speed': is3DView,
'zoom-large': largeZoom,
'zoom-close': !largeZoom,
'data-open': showData,
'data-close': !showData,
'controls-open': showControls,
'controls-close': !showControls
}">
  <div id="navbar">
    <a id="toggle-data" href="#data" (click)="showData = !showData"><i class="icon-data"></i>Data</a>
    <h1>3D Solar System<br><span>by <a href="https://twitter.com/JulianGarnier" target="_blank">@JulianGarnier</a></span></h1>
    <a id="toggle-controls" href="#controls" (click)="showControls = !showControls"><i class="icon-controls"></i>Controls</a>
  </div>
  <div id="data">
    <a class="sun" title="sun" [ngClass]="{'active': dataClass === 'sun'}" (click)="dataClass = 'sun'">Sun</a>
    <a class="mercury" title="mercury" [ngClass]="{'active': dataClass === 'mercury'}" (click)="dataClass = 'mercury'">Mercury</a>
    <a class="venus" title="venus" [ngClass]="{'active': dataClass === 'venus'}" (click)="dataClass = 'venus'">Venus</a>
    <a class="earth active" title="earth" [ngClass]="{'active': dataClass === 'earth'}" (click)="dataClass = 'earth'">Earth</a>
    <a class="mars" title="mars" [ngClass]="{'active': dataClass === 'mars'}" (click)="dataClass = 'mars'">Mars</a>
    <a class="jupiter" title="jupiter" [ngClass]="{'active': dataClass === 'jupiter'}" (click)="dataClass = 'jupiter'">Jupiter</a>
    <a class="saturn" title="saturn" [ngClass]="{'active': dataClass === 'saturn'}" (click)="dataClass = 'saturn'">Saturn</a>
    <a class="uranus" title="uranus" [ngClass]="{'active': dataClass === 'uranus'}" (click)="dataClass = 'uranus'">Uranus</a>
    <a class="neptune" title="neptune" [ngClass]="{'active': dataClass === 'neptune'}" (click)="dataClass = 'neptune'">Neptune</a>
  </div>
  <div id="controls">
    <label class="set-view" (click)="is3DView = !is3DView">
      <input type="checkbox">
    </label>
    <label class="set-zoom" (click)="largeZoom = !largeZoom">
      <input type="checkbox">
    </label>
    <label>
      <input type="radio" class="set-speed" name="scale" checked (click)="universeMode = 'speed'">
      <span>Speed</span>
    </label>
    <label>
      <input type="radio" class="set-size" name="scale" (click)="universeMode = 'size'">
      <span>Size</span>
    </label>
    <label>
      <input type="radio" class="set-distance" name="scale" (click)="universeMode = 'distance'">
      <span>Distance</span>
    </label>
  </div>
  <div id="universe" class="scale-stretched"
       [ngClass]="{
'scale-stretched': universeMode === 'speed',
'set-speed': universeMode === 'speed',
'scale-s': universeMode === 'size',
'set-size': universeMode === 'size',
'scale-d': universeMode === 'distance',
'set-distance': universeMode === 'distance'
}">
    <div id="galaxy">
      <div id="solar-system" [ngClass]="dataClass">
        <div id="mercury" class="orbit">
          <div class="pos">
            <div class="planet">
              <dl class="infos">
                <dt>Mercury</dt>
                <dd><span></span></dd>
              </dl>
            </div>
          </div>
        </div>
        <div id="venus" class="orbit">
          <div class="pos">
            <div class="planet">
              <dl class="infos">
                <dt>Venus</dt>
                <dd><span></span></dd>
              </dl>
            </div>
          </div>
        </div>
        <div id="earth" class="orbit">
          <div class="pos">
            <div class="orbit">
              <div class="pos">
                <div class="moon"></div>
              </div>
            </div>
            <div class="planet">
              <dl class="infos">
                <dt>Earth</dt>
                <dd><span></span></dd>
              </dl>
            </div>
          </div>
        </div>
        <div id="mars" class="orbit">
          <div class="pos">
            <div class="planet">
              <dl class="infos">
                <dt>Mars</dt>
                <dd><span></span></dd>
              </dl>
            </div>
          </div>
        </div>
        <div id="jupiter" class="orbit">
          <div class="pos">
            <div class="planet">
              <dl class="infos">
                <dt>Jupiter</dt>
                <dd><span></span></dd>
              </dl>
            </div>
          </div>
        </div>
        <div id="saturn" class="orbit">
          <div class="pos">
            <div class="planet">
              <div class="ring"></div>
              <dl class="infos">
                <dt>Saturn</dt>
                <dd><span></span></dd>
              </dl>
            </div>
          </div>
        </div>
        <div id="uranus" class="orbit">
          <div class="pos">
            <div class="planet">
              <dl class="infos">
                <dt>Uranus</dt>
                <dd><span></span></dd>
              </dl>
            </div>
          </div>
        </div>
        <div id="neptune" class="orbit">
          <div class="pos">
            <div class="planet">
              <dl class="infos">
                <dt>Neptune</dt>
                <dd><span></span></dd>
              </dl>
            </div>
          </div>
        </div>
        <div id="sun">
          <dl class="infos">
            <dt>Sun</dt>
            <dd><span></span></dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</body>
